<template>
    <div>
        <v-col>
            <div class="px-1">Item Types:</div>
            <v-checkbox hide-details value="Pallet" v-model="selectedContainerTypes" color="primary" label="Pallet"></v-checkbox>
            <v-checkbox hide-details value="Skid" v-model="selectedContainerTypes" color="primary" label="Skid"></v-checkbox>
            <v-checkbox hide-details value="Crate" v-model="selectedContainerTypes" color="primary" label="Crate"></v-checkbox>
        </v-col>

        <v-col>
            <div class="px-1">Additional Options:</div>
            <v-switch v-model="dynamicLength" color="primary" label="Adjust length to accommodate the largest item size"></v-switch>
        </v-col>
    </div>
</template>

<script>

export default {
    props: {
        itemTypes: Array,
        formData: Object
    },

    data() {
        return {
            dynamicLength: false,
            selectedContainerTypes: ['Pallet', 'Skid', 'Crate']
        }
    },

    watch: {
        selectedContainerTypes(newVal) {
            this.formData.options.containerTypes = newVal;
        },
        dynamicLength(newVal) {
            this.formData.options.dynamicLength = newVal;
        }
    },

    created() {
        // Initialize formData.options if it is null or undefined
        if (this.formData.options === null || this.formData.options == undefined || Object.keys(this.formData.options).length === 0) {
            this.formData.options = {} // important: Initialize options object
        }

        // Initialize containerTypes if it is null or undefined
        if(this.formData.options.containerTypes === null || this.formData.options.containerTypes == undefined) {
            this.formData.options.containerTypes = this.selectedContainerTypes;
        } else {
            this.selectedContainerTypes = this.formData.options.containerTypes;
        }

        // Initialize dynamicLength if it is null or undefined
        if(this.formData.options.dynamicLength === null || this.formData.options.dynamicLength == undefined) {
            this.formData.options.dynamicLength = this.dynamicLength;
        } else {
            this.dynamicLength = this.formData.options.dynamicLength;
        }
    }
}
</script>
